import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { getJobLogs } from "../Scrapper/api";
import useAppStore from "../../store/global";
import LogsScreen from "../Scrapper/Logs/LogsScreen";
import Paginator from "../Common/Paginator";

function LogsModal({ show, setShow, id }) {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const { pageSize, dateRange, logType } = useAppStore();
  const [pageNum, setPageNum] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const fetchLogs = () => {
    setLoading(true);
    getJobLogs(id, dateRange, pageNum, logType)
      .then((data) => {
        setLogs(data.job_logs);
        setTotalPages(data.totalPages);
        setLoading(false);
      })
      .catch((err) => {
        console.log("error", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!show || !id) return
    fetchLogs();
    const intervalId = setInterval(() => {
      fetchLogs();
    }, 8000);

    return () => clearInterval(intervalId);
  }, [pageNum, dateRange, logType, id]);

  return (
    <>
      <Modal show={show} fullscreen={true} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Logs</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mx-4" style={{ marginTop: "50px" }}>
            {!logs && !loading && <h3>No logs found</h3>}
            <>
              <LogsScreen logs={logs} height="880px" />
              <Paginator
                pageNum={pageNum}
                setPageNum={setPageNum}
                totalPages={totalPages}
              />
            </>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default LogsModal;
